import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

/**
 * A collapsed settings row: name on the left, its current value on the right.
 *
 * Reading name → value across one line is how a settings list is scanned. The
 * first cut stacked the value under the name, which turned five sections into
 * ten lines of alternating bold and grey with no shape to them.
 *
 * The value is not decoration — it is what lets someone read the whole campaign
 * without opening anything, so it must always say something.
 */
export function Section({
  value,
  title,
  summary,
  single,
  children,
}: {
  value: string;
  title: string;
  summary: string;
  /** Wraps itself in an Accordion, for a section standing on its own. */
  single?: boolean;
  children: React.ReactNode;
}): React.ReactElement {
  const item = (
    <AccordionItem value={value} className="border-b-0 px-4">
      <AccordionTrigger className="gap-4 py-3.5 text-sm hover:no-underline">
        <span className="shrink-0 font-medium">{title}</span>
        <span className="flex-1 truncate text-right text-sm font-normal text-muted-foreground">
          {summary}
        </span>
      </AccordionTrigger>
      <AccordionContent className="pb-4">{children}</AccordionContent>
    </AccordionItem>
  );

  if (!single) return item;
  return (
    <Accordion type="single" collapsible>
      {item}
    </Accordion>
  );
}
